<template>
    <div v-if="isVerifiedUser" class="mb-3" :class="sizeClassObject">
        <div class="card h-100">
            <div class="card-header">
                <h5 class="card-title">{{$t('home.myForms')}}</h5>
            </div>
            <div class="card-body">
                <div v-if="myForms.length">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">{{$t('home.myForms')}}</th>
                                <th scope="col">{{$t('home.type')}}</th>
                                <th scope="col">{{$t('home.event')}}</th>
                                <th scope="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in myForms" :key="'myEvents'+index">
                                <th scope="row">{{index+1}}</th>
                                <td>{{item.formName}}</td>
                                <td>{{item.formType}}</td>
                                <td>{{item.eventName}}</td>
                                <td>
                                    <router-link :to="{ path: `/forms/entryDetails?id=${item.formToRegisterEntityId}&entryId=${item.id}&name=${item.eventName}&returnUrl=${returnUrl}`}"
                                                    replace
                                                    :title="$t('buttons.open')">
                                        <i class="fa fa-external-link-alt"></i>
                                    </router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else>
                    <span class="text-danger">{{$t('home.noData')}}</span>
                </div>
            </div>
            <div class="card-footer">
                <router-link :to="{ path: '/account?tab=activeFormsTab'}" replace class="card-link">{{$t('home.showMore')}}</router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import { Role } from '../../helpers/role';

    export default {
        props: {
            size: Number
        },
        data() {
            return {
                myForms: [],
                returnUrl: '/'
            }
        },
        computed: {
            isVerifiedUser() {
                return this.$store.getters.userRoles.includes(Role.VerifiedUser)
                    || this.$store.getters.userRoles.includes(Role.Participant);
            },
            sizeClassObject() {
                return this.$helpers.sizeClassObject(this.size);
            },
        },
        methods: {
            loadMyForms() {
                this.$http
                    .post('api/dynamicForms/listMy', { Request: { take: 5 } })
                    .then(result => {
                        this.myForms = result.data.data;
                    })
                    .catch(err => console.log(err));
            }
        },
        mounted() {
            this.loadMyForms();
        }
    }
</script>
